export enum DiseaseClasssificationEnum {
	RECOVERD = 1,
	UNDERTREATMENT = 2,
	UNTREATEDMENT = 3,
}
